"use client";

import JobDetailContent, { type JobData } from "@/components/Company/JobDetailContent";

const jobData: JobData = {
  title: "Frontend Developer",
  sections: [
    {
      title: "Responsibilities",
      items: [
        "Assessment (Blind/Full knowledge).",
        "Design & Architecture review.",
        "Implementation review.",
        "Protocol review.",
        "Product usage review.",
        "Training.",
      ],
    },
    {
      title: "Skills and Experience",
      items: [
        "Experienced in HTML5/CSS3, JavaScript/TypeScript and pre-processing languages such as LESS/SASS/SCSS.",
        "At least 2 year experience in NodeJS, ReactJS, Redux.",
        "Strong knowledge of development based on REST API.",
        "Experience working with system design, database architecture, and middleware development.",
        "Good awareness about security and performance in web development.",
        "Solid understanding of HTML & CSS modular development and browser compatibility.",
        "Cross-browser compatibility, troubleshooting, debugging, optimizing page performance.",
        "Working knowledge in source version control (GIT).",
        "Experience in Scrum, Git is a huge priority.",
        "Be proactive in identifying and solving problems.",
        "Ability to independent work directly with tasks. Strong responsibility.",
        "Be able to communicate in English.",
      ],
    },
    {
      title: "Big Bonus",
      items: [
        "Knowledge of Realtime Communication (Pusher, PubNub, FireBase).",
        "Ambition to learn more about UI/UX and design is highly valued.",
        "Good at English communication.",
        "Good design and aesthetic sense.",
      ],
    },
  ],
  closingNote:
    "ECQ firmly believes in Skills and Quality of Work. No certification or degree is required. All candidates are welcomed and will be screened through technical interview. All applications will be treated as strictly confidential. Successful candidate will receive attractive remuneration package. Interested applicants please submit your application and resume with a recent photo either by post or e-mail to the following address.",
  applyEmail: "hr@e-cq.net",
};

export default function FrontendDeveloperJD() {
  return <JobDetailContent data={jobData} />;
}
